var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinusButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 25C1 11.7452 11.7452 1 25 1C38.2548 1 49 11.7452 49 25C49 38.2548 38.2548 49 25 49C11.7452 49 1 38.2548 1 25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 25.998H19C18.7348 25.998 18.4804 25.8926 18.2929 25.7051C18.1054 25.5176 18 25.2632 18 24.998C18 24.7328 18.1054 24.4784 18.2929 24.2909C18.4804 24.1033 18.7348 23.998 19 23.998H31C31.2652 23.998 31.5196 24.1033 31.7071 24.2909C31.8946 24.4784 32 24.7328 32 24.998C32 25.2632 31.8946 25.5176 31.7071 25.7051C31.5196 25.8926 31.2652 25.998 31 25.998Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48C12.2975 48 2 37.7025 2 25H0C0 38.8071 11.1929 50 25 50V48ZM48 25C48 37.7025 37.7025 48 25 48V50C38.8071 50 50 38.8071 50 25H48ZM25 2C37.7025 2 48 12.2975 48 25H50C50 11.1929 38.8071 0 25 0V2ZM25 0C11.1929 0 0 11.1929 0 25H2C2 12.2975 12.2975 2 25 2V0Z",
    fill: "#DDDDDD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusButton);
export default __webpack_public_path__ + "static/media/minus-button.0bd150b2c261b3d4f14c1ecab8c35b04.svg";
export { ForwardRef as ReactComponent };